import {
  Linking,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native'
import { urls } from '@linqpal/models/src/dictionaries'
import { LogoDark } from '../../assets/icons'
import React, { FC } from 'react'
import { useResponsive } from '../../utils/hooks'

interface IApprovalPageContainerProps {
  title: string
  children: React.ReactNode
}

export const ApprovalPageContainer: FC<IApprovalPageContainerProps> = ({
  title,
  children,
}) => {
  const { sm } = useResponsive()

  return (
    <>
      <View style={styles.container}>
        {sm ? (
          <TouchableOpacity
            onPress={() => Linking.openURL(urls.BT)}
            style={styles.logo}
          >
            <LogoDark width={sm ? 163 : 122} height={sm ? 20 : 16} />
          </TouchableOpacity>
        ) : null}
        <Text style={styles.title}>{title}</Text>
      </View>
      <ScrollView
        style={{ width: sm ? 880 : 370, alignSelf: 'center', marginTop: 35 }}
      >
        {children}
      </ScrollView>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    padding: 20,
    borderBottomWidth: 1,
    borderColor: '#EBEEEF',
  },
  logo: {
    left: 20,
    position: 'absolute',
  },
  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '600',
    fontSize: 20,
    textAlign: 'center',
  },
})
